export default __webpack_public_path__ + "f07792dd8f88440acb45385023a492ac.svg";